import { createSelector } from "reselect";

import type { TripLeg } from "@busbud/int-schemas/udm";

import { getCartTripItem } from "./get-cart-trip-item";

const EMPTY_CART_TRIP_ITEMS: Omit<TripLeg, "segment_xids">[] = [];
/**
 * @description Similar of `getTripLegsByTripId`. At this point it's fixed to 1 cart trip item.
 * @returns all legs from cart trip item.
 */
export const getCartTripItemLegs = createSelector(
  [getCartTripItem],
  cart_trip_item => {
    if (!cart_trip_item) {
      return EMPTY_CART_TRIP_ITEMS;
    }

    return cart_trip_item.trip_legs;
  }
);

export const getCartTripItemLegsSegmentIds = createSelector(
  [getCartTripItemLegs],
  trip_legs => {
    return trip_legs.map(trip_leg => trip_leg.segment_ids || []);
  }
);
